import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { parseColorFilename } from "./colorsPageUtils";

const INITIAL_DATA = {
  groupName: "",
  materialType: "MDF",
  active: true,
  rotable: false,
  splitDimension: false,
  painted: false,
  price: 0
};

export default function BulkColorModal({
  show,
  onHide,
  onInsert,
  insertLoading
}) {
  const [commonData, setCommonData] = useState(INITIAL_DATA);
  const [colors, setColors] = useState([]);
  const handleFileUpload = (event) =>
    setColors(
      Array.from(event.target.files).map((file) => ({
        file,
        ...parseColorFilename(file.name)
      }))
    );
  const handleInsert = () => {
    onInsert(
      colors.map((color) => ({
        colorId: color.colorId,
        name: color.colorName,
        ...commonData,
        dimension: color.dimension,
        imageFile: color.file
      }))
    );
    setColors([]);
    setCommonData(INITIAL_DATA);
  };
  const updateCommon = (field, value) =>
    setCommonData((data) => ({ ...data, [field]: value }));

  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Szín tömeges beszúrása</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          <label className="form-label fw-bold">Képek feltöltése</label>
          <input
            type="file"
            multiple
            accept="image/*"
            className="form-control"
            onChange={handleFileUpload}
          />
        </div>
        <div className="mb-4 p-3 bg-light border rounded">
          <h5 className="mb-3">Közös beállítások</h5>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Csoport</label>
              <input
                className="form-control"
                value={commonData.groupName}
                onChange={(event) =>
                  updateCommon("groupName", event.target.value)
                }
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Anyag típusa</label>
              <select
                className="form-control"
                value={commonData.materialType}
                onChange={(event) =>
                  updateCommon("materialType", event.target.value)
                }
              >
                <option>MDF</option>
                <option>PAL</option>
                <option>Gizir</option>
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Ár</label>
              <input
                type="number"
                step="0.01"
                className="form-control"
                value={commonData.price}
                onChange={(event) =>
                  updateCommon("price", parseFloat(event.target.value) || 0)
                }
              />
            </div>
            {["painted", "active", "rotable"].map((field) => (
              <div className="col-md-6 mb-3" key={field}>
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={commonData[field]}
                    onChange={(event) =>
                      updateCommon(field, event.target.checked)
                    }
                  />
                  <label className="form-check-label">{field}</label>
                </div>
              </div>
            ))}
          </div>
        </div>
        {colors.length > 0 && (
          <div className="row">
            {colors.map((color, index) => (
              <div key={index} className="col-md-3 mb-3">
                <div className="card p-2 h-100">
                  <img
                    src={URL.createObjectURL(color.file)}
                    style={{
                      width: "100%",
                      height: "100px",
                      objectFit: "cover"
                    }}
                    alt={color.colorName}
                  />
                  <small className="text-muted mt-2">{color.file.name}</small>
                  <input
                    className="form-control form-control-sm mt-2"
                    value={color.colorId || ""}
                    placeholder="ID"
                    onChange={(event) =>
                      setColors((items) =>
                        items.map((item, itemIndex) =>
                          itemIndex === index
                            ? { ...item, colorId: event.target.value || null }
                            : item
                        )
                      )
                    }
                  />
                  <input
                    className="form-control form-control-sm mt-2"
                    value={color.colorName}
                    onChange={(event) =>
                      setColors((items) =>
                        items.map((item, itemIndex) =>
                          itemIndex === index
                            ? { ...item, colorName: event.target.value }
                            : item
                        )
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Mégse
        </Button>
        <Button
          variant="success"
          onClick={handleInsert}
          disabled={!colors.length || insertLoading}
        >
          {insertLoading ? "Feltöltés..." : `Beszúrás (${colors.length})`}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
